"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectPicker = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var VizportalApi_1 = require("../../vizportalapi/VizportalApi");
/* tslint:disable:import-blacklist */
var nested_project_explorer_1 = require("@tableau/nested-project-explorer");
var ProjectPicker = /** @class */ (function (_super) {
    __extends(ProjectPicker, _super);
    function ProjectPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { projects: null, selectedProjectId: '' };
        _this.projectSelected = _this.projectSelected.bind(_this);
        return _this;
    }
    ProjectPicker.prototype.projectSelected = function (project) {
        var projectId = project !== null ? project.id : '';
        this.props.onProjectSelected(projectId);
    };
    // Only set the initial project selected after we've collected all data
    // and have rendereded the project explorer
    ProjectPicker.prototype.onInitialProjectSelected = function () {
        if (this.haveDataToRenderProjectExplorer()) {
            this.props.onProjectSelected(this.state.selectedProjectId);
        }
    };
    ProjectPicker.prototype.componentDidMount = function () {
        var _this = this;
        // FIXME
        // tslint:disable-next-line:no-floating-promises
        VizportalApi_1.VizportalApiService.GetDestinationProjects().then(function (projects) {
            var destinationProjects = projects.map(function (project) { return ({
                id: project.id,
                name: project.name,
                parentId: project.parentProjectId,
                childItemCount: project.childProjectCount,
                topLevelItem: project.topLevelProject,
                controlledPermissionsEnabled: project.controlledPermissionsEnabled,
                status: project.status,
                itemType: nested_project_explorer_1.DestinationItemType.project,
            }); });
            _this.setState({ projects: destinationProjects });
            _this.onInitialProjectSelected();
        });
    };
    ProjectPicker.prototype.haveDataToRenderProjectExplorer = function () {
        return this.state.projects !== null;
    };
    ProjectPicker.prototype.render = function () {
        if (this.haveDataToRenderProjectExplorer()) {
            return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerContainerDiv },
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerDiv },
                    React.createElement(nested_project_explorer_1.NestedProjectExplorer, { topLevelDestinationStatus: 'structurally_invalid', projects: nested_project_explorer_1.NestedItemsTreeHelper.convertItemListToTrees(this.state.projects), onSelectedProjectChanged: this.projectSelected }))));
        }
        else {
            return (React.createElement("div", { className: "tab-fill-centered " + WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerContainerDiv },
                React.createElement(widgets_1.ActivitySpinnerWidget, { testId: 'waiting' })));
        }
    };
    return ProjectPicker;
}(React.PureComponent));
exports.ProjectPicker = ProjectPicker;
//# sourceMappingURL=ProjectPicker.js.map